export default __webpack_public_path__ + "static/media/pwd-feedback.d6d8ae1e.png";